module.exports = __webpack_public_path__ + "static/media/BigText5050.190585d4.png";